export default "__VITE_ASSET__D5W8j7c5__"